import { CustomError } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { SaleDTO, InvoiceParamsFromPosDTO, Permission } from 'core/api';

import { InvoiceDocument } from 'pos/modules/helpers/document-creation/Invoice';
import { Command } from 'pos/common';
import { showCloseDocumentScreen } from 'pos/modules/helpers/document-creation';

type ChangeInvoicePaymentParams = {
	getDocument: () => InvoiceDocument,
	changePayment: (params: InvoiceParamsFromPosDTO) => Promise<Result<SaleDTO, CustomError>>
};

declare global {
	interface CommandType {
		changeInvoicePayments: (params: ChangeInvoicePaymentParams) => Promise<Result>
	}
}

Command.register('changeInvoicePayments', Preconditions.ensure(Permission.Ticket_ChangePayment), async (params: ChangeInvoicePaymentParams): Promise<Result> => {
	return showCloseDocumentScreen({
		layout: 'ChangeInvoicePayment',
		getDocument: params.getDocument,
		setCustomer: async () => { },
		closeDocument: params.changePayment
	});
});
